const THEME_KEY = 'brb_theme';
const DEFAULT_THEME = 'parchment';
const THEMES = ['ledger', 'parchment', 'quarried-slate', 'ink', 'slate', 'wine'];

const themeSelect = document.getElementById('themeSelect');

const applyTheme = (theme) => {
  document.documentElement.setAttribute('data-theme', theme);
  document.dispatchEvent(new CustomEvent('themechange', { detail: { theme } }));
};

export const initTheme = () => {
  let stored = DEFAULT_THEME;
  try {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved && THEMES.includes(saved)) stored = saved;
  } catch {}

  applyTheme(stored);
  if (themeSelect) themeSelect.value = stored;

  themeSelect?.addEventListener('change', (event) => {
    const theme = THEMES.includes(event.target.value) ? event.target.value : DEFAULT_THEME;
    applyTheme(theme);
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {}
  });
};
